if (!customElements.get('product-info')) {
  customElements.define(
    'product-info',
    class ProductInfo extends HTMLElement {
      quantityInput = undefined;
      quantityForm = undefined;
      onVariantChangeUnsubscriber = undefined;
      cartUpdateUnsubscriber = undefined;
      abortController = undefined;
      pendingRequestUrl = null;
      preProcessHtmlCallbacks = [];
      postProcessHtmlCallbacks = [];

      constructor() {
        super();
        this.quantityInput = this.querySelector('.quantity__input');
      }

      connectedCallback() {
        this.initializeProductSwapUtility();

        this.onVariantChangeUnsubscriber = subscribe(
          PUB_SUB_EVENTS.optionValueSelectionChange,
          this.handleOptionValueChange.bind(this)
        );

        this.initQuantityHandlers();
        this.dispatchEvent(new CustomEvent('product-info:loaded', { bubbles: true }));

        this.querySelectorAll("input[option-name='option--product-type']").forEach((target, index, arr) => {
          if (arr.length > 1) {
            if (target) target?.hasAttribute('checked') ? this.thumbMediaVariant(target) : '';
          }

          // if(target) target?.hasAttribute('checked') ? this.productVariantInfo(target) : '';

          this.querySelector('#explore-more-button')?.addEventListener('click', () => {
            if (target) target?.hasAttribute('checked') ? this.exploreMoreProduct(target) : '';
          });

          this.querySelector('#size-chart-button')?.addEventListener('click', () => {
            if (target) target?.hasAttribute('checked') ? this.sizeGuide(target) : '';
          });
        });

        this.querySelector('#size-chart-button')?.addEventListener('click', () => {
          const sizeGuidePopup = document.querySelector('.product-sizing-guide-container');
          const sizeBuideBtn = this.querySelector('#size-chart-button');
          if (sizeBuideBtn) {
            sizeGuidePopup?.classList.remove('hidden');
          }
        });
      }

      addPreProcessCallback(callback) {
        this.preProcessHtmlCallbacks.push(callback);
      }

      initQuantityHandlers() {
        if (!this.quantityInput) return;

        this.quantityForm = this.querySelector('.product-form__quantity');
        if (!this.quantityForm) return;

        this.setQuantityBoundries();
        if (!this.dataset.originalSection) {
          this.cartUpdateUnsubscriber = subscribe(PUB_SUB_EVENTS.cartUpdate, this.fetchQuantityRules.bind(this));
        }
      }

      disconnectedCallback() {
        this.onVariantChangeUnsubscriber();
        this.cartUpdateUnsubscriber?.();
      }

      initializeProductSwapUtility() {
        this.preProcessHtmlCallbacks.push((html) =>
          html.querySelectorAll('.scroll-trigger').forEach((element) => element.classList.add('scroll-trigger--cancel'))
        );
        this.postProcessHtmlCallbacks.push((newNode) => {
          window?.Shopify?.PaymentButton?.init();
          window?.ProductModel?.loadShopifyXR();
        });
      }

      handleOptionValueChange({ data: { event, target, selectedOptionValues } }) {
        if (!this.contains(event.target)) return;

        this.resetProductFormState();

        const productUrl = target.dataset.productUrl || this.pendingRequestUrl || this.dataset.url;
        this.pendingRequestUrl = productUrl;
        const shouldSwapProduct = this.dataset.url !== productUrl;
        const shouldFetchFullPage = this.dataset.updateUrl === 'true' && shouldSwapProduct;

        this.renderProductInfo({
          requestUrl: this.buildRequestUrlWithParams(productUrl, selectedOptionValues, shouldFetchFullPage),
          targetId: target.id,
          callback: shouldSwapProduct
            ? this.handleSwapProduct(productUrl, shouldFetchFullPage)
            : this.handleUpdateProductInfo(productUrl),
        });

        this.thumbMediaVariant(target);

        setTimeout(() => {
          this.sliderArrow();
        }, 2000);
      }

      thumbMediaVariant(target) {
        let optionName = (target.getAttribute('option-name') || '').trim();
        if (optionName === 'option--product-type') {
          const selectedAlt = (target.value || '').trim();
          document.querySelectorAll('.thumbnail-list__item').forEach(thumbnailMedia => {
            const thumbnailMediaAlt = (thumbnailMedia.getAttribute('data-alt') || '').trim();
            const shouldShow = thumbnailMediaAlt === selectedAlt;
            shouldShow ? thumbnailMedia.classList.remove('hidden') : thumbnailMedia.classList.add('hidden');
          });
        }
      }


      sliderArrow() {
        const thumbnailItems = this.querySelectorAll('.thumbnail-list__item:not(.hidden)');
        const thumbSlider = this.querySelector('.thumbnail-slider');
        const sliderButtons = this.querySelectorAll('.thumbnail-slider .slider-button');
        const visibleSlideCount = thumbnailItems ? thumbnailItems.length : 0;
        const screenWidth = window.innerWidth;

        if (thumbSlider) {
          if ((screenWidth <= 750 && visibleSlideCount <= 4) || (screenWidth > 750 && visibleSlideCount <= 6)) {
            sliderButtons.forEach(btn => btn.setAttribute('disabled', 'disabled'));
            console.log('arrow desabled on variant changed');
          } else {
            document.querySelector('button.slider-button--next[disabled=disabled]')?.removeAttribute('disabled');
          }
        }

        if (visibleSlideCount === 0) {
          sliderButtons.forEach(btn => {
            btn.style.display = 'none';
          });
        } else {
          sliderButtons.forEach(btn => {
            btn.style.display = '';
          });
        }
      }

      resetProductFormState() {
        const productForm = this.productForm;
        productForm?.toggleSubmitButton(true);
        productForm?.handleErrorMessage();
      }

      handleSwapProduct(productUrl, updateFullPage) {
        return (html) => {
          this.productModal?.remove();

          const selector = updateFullPage ? "product-info[id^='MainProduct']" : 'product-info';
          const variant = this.getSelectedVariant(html.querySelector(selector));
          this.updateURL(productUrl, variant?.id);

          if (updateFullPage) {
            document.querySelector('head title').innerHTML = html.querySelector('head title').innerHTML;

            HTMLUpdateUtility.viewTransition(
              document.querySelector('main'),
              html.querySelector('main'),
              this.preProcessHtmlCallbacks,
              this.postProcessHtmlCallbacks
            );
          } else {
            HTMLUpdateUtility.viewTransition(
              this,
              html.querySelector('product-info'),
              this.preProcessHtmlCallbacks,
              this.postProcessHtmlCallbacks
            );
          }
        };
      }

      renderProductInfo({ requestUrl, targetId, callback }) {
        this.abortController?.abort();
        this.abortController = new AbortController();
        fetch(requestUrl, { signal: this.abortController.signal })
          .then((response) => response.text())
          .then((responseText) => {
            this.pendingRequestUrl = null;
            const html = new DOMParser().parseFromString(responseText, 'text/html');
            callback(html);
          })
          .then(() => {
            // set focus to last clicked option value
            document.querySelector(`#${targetId}`)?.focus();
          })
          .catch((error) => {
            if (error.name === 'AbortError') {
              console.log('Fetch aborted by user');
            } else {
              console.error(error);
            }
          });
      }

      getSelectedVariant(productInfoNode) {
        const selectedVariant = productInfoNode.querySelector('variant-selects [data-selected-variant]')?.innerHTML;
        return !!selectedVariant ? JSON.parse(selectedVariant) : null;
      }

      buildRequestUrlWithParams(url, optionValues, shouldFetchFullPage = false) {
        const params = [];

        !shouldFetchFullPage && params.push(`section_id=${this.sectionId}`);

        if (optionValues.length) {
          params.push(`option_values=${optionValues.join(',')}`);
        }

        return `${url}?${params.join('&')}`;
      }

      // updateOptionValues(html) {
      //   const variantSelects = html.querySelector('variant-selects');
      //   if (variantSelects) {
      //     HTMLUpdateUtility.viewTransition(this.variantSelectors, variantSelects, this.preProcessHtmlCallbacks);
      //     console.log('html - ',html);
      //     this.querySelectorAll("input[option-name='option--product-type']")?.forEach((target) => {
      //       this.querySelector('#explore-more-button')?.addEventListener('click', () => {
      //         if (target) target?.hasAttribute('checked') ? this.exploreMoreProduct(target) : '';
      //       });
      //       this.querySelector('#size-chart-button')?.addEventListener('click', () => {
      //         if (target) target?.hasAttribute('checked') ? this.sizeGuide(target) : '';
      //       });
      //       this.querySelector('#size-chart-button')?.addEventListener('click', () => {
      //         const sizeGuidePopup = document.querySelector('.product-sizing-guide-container');
      //         const sizeBuideBtn = this.querySelector('#size-chart-button');
      //         if (sizeBuideBtn) {
      //           sizeGuidePopup.classList.remove('hidden');
      //         }
      //       });

      //       if (target) target?.hasAttribute('checked') break;
      //     });
      //   }
      // }


      // updateOptionValues(html) {
      //   const variantSelects = html.querySelector('variant-selects');
      //   if (variantSelects) {
      //     HTMLUpdateUtility.viewTransition(this.variantSelectors, variantSelects, this.preProcessHtmlCallbacks);
      //     this.querySelectorAll("input[option-name='option--product-type']").forEach((target) => {
      //       this.querySelector('#explore-more-button').addEventListener('click', () => {
      //         if (target) target?.hasAttribute('checked') ? this.exploreMoreProduct(target) : '';
      //       });
      //       this.querySelector('#size-chart-button').addEventListener('click', () => {
      //         if (target) target?.hasAttribute('checked') ? this.sizeGuide(target) : '';
      //       });
      //     });
      //   }
      // }

      updateOptionValues(html) {
        const variantSelects = html.querySelector('variant-selects');
        if (!variantSelects) return;

        HTMLUpdateUtility.viewTransition(
          this.variantSelectors,
          variantSelects,
          this.preProcessHtmlCallbacks
        );

        const exploreMoreButton = this.querySelector('#explore-more-button');
        const sizeChartButton = this.querySelector('#size-chart-button');
        const sizeGuidePopup = document.querySelector('.product-sizing-guide-container');

        const popupWrapper = this.querySelector('.explore-more-product-popup-head');
        if (popupWrapper) {
          const quickAdd = popupWrapper?.closest('.quick-add-modal__content');
          quickAdd?.classList.remove('overflow-hidden');
        }

        this.querySelectorAll("input[option-name='option--product-type']").forEach((target) => {
            // this.querySelector('#explore-more-button').addEventListener('click', () => {
            //   if (target) target?.hasAttribute('checked') ? this.exploreMoreProduct(target) : '';
            // });
            this.querySelector('#size-chart-button')?.addEventListener('click', () => {
              if (target) target?.hasAttribute('checked') ? this.sizeGuide(target) : '';
            });
        });

        const productTypeOptions = this.querySelectorAll("input[option-name='option--product-type']");
        if (!productTypeOptions.length) return;

        for (const target of productTypeOptions) {
          if (exploreMoreButton) {
            exploreMoreButton.addEventListener('click', () => {
              if (target.hasAttribute('checked')) {
                this.exploreMoreProduct(target);
              }
            });
          }

          if (target.hasAttribute('checked')) break;
        }
      }

      handleUpdateProductInfo(productUrl) {
        return (html) => {
          const variant = this.getSelectedVariant(html);
          let priceLoader = this.querySelector('.price-loader');
          this.pickupAvailability?.update(variant);
          this.updateOptionValues(html);
          this.updateURL(productUrl, variant?.id);
          this.updateVariantInputs(variant?.id);

          if (!variant) {
            this.setUnavailable(priceLoader);
            this.setUnavailableOptions();
            return;
          }

          // priceLoader.classList.remove('hidden');

          this.updateMedia(html, variant?.featured_media?.id);

          const updateSourceFromDestination = (id, shouldHide = (source) => false) => {
            const source = html.getElementById(`${id}-${this.sectionId}`);
            const destination = this.querySelector(`#${id}-${this.dataset.section}`);
            if (source && destination) {
              destination.innerHTML = source.innerHTML;
              destination.classList.toggle('hidden', shouldHide(source));
              // let priceConatiner = document.querySelector('.product__info-container .main-product-pirce');
              priceLoader.classList.add('hidden');
              // priceConatiner.classList.remove('hidden');
            }
          };

          updateSourceFromDestination('price');
          updateSourceFromDestination('Sku', ({ classList }) => classList.contains('hidden'));
          updateSourceFromDestination('Inventory', ({ innerText }) => innerText === '');
          updateSourceFromDestination('Volume');
          updateSourceFromDestination('Price-Per-Item', ({ classList }) => classList.contains('hidden'));

          this.updateQuantityRules(this.sectionId, html);
          this.querySelector(`#Quantity-Rules-${this.dataset.section}`)?.classList.remove('hidden');
          this.querySelector(`#Volume-Note-${this.dataset.section}`)?.classList.remove('hidden');

          this.productForm?.toggleSubmitButton(
            html.getElementById(`ProductSubmitButton-${this.sectionId}`)?.hasAttribute('disabled') ?? true,
            window.variantStrings.soldOut
          );

          publish(PUB_SUB_EVENTS.variantChange, {
            data: {
              sectionId: this.sectionId,
              html,
              variant,
            },
          });
        };
      }

      setUnavailableOptions() {
        const productOptionsStyle = this.querySelectorAll("input[option-name='option--style']");
        if (productOptionsStyle) {
          for (const productOption of productOptionsStyle) {
            const optionName = productOption.getAttribute('option-name');
            if (optionName === 'option--style') {
              const isDisabled = productOption.classList.contains('disabled');
              if (!isDisabled) {
                const productOptionLabel = productOption.nextElementSibling;
                if (productOptionLabel) {
                  productOptionLabel.click();
                  break; //
                }
              }
            }
          }
        }
        const productOptionsSize = this.querySelectorAll("input[option-name='option--size']");
        if (productOptionsSize) {
          for (const productOption of productOptionsSize) {
            const optionName = productOption.getAttribute('option-name');
            if (optionName === 'option--size') {
              const isDisabled = productOption.classList.contains('disabled');
              if (!isDisabled) {
                const productOptionLabel = productOption.nextElementSibling;
                if (productOptionLabel) {
                  productOptionLabel.click();
                  break; //
                }
              }
            }
          }
        }
      }

      exploreMoreProduct(selectedOption) {
        const popupWrapper = this.querySelector('.explore-more-product-popup-head');
        const exploreMoreGrid = this.querySelector('#explore_more_grid');
        const quickAdd = popupWrapper?.closest('.quick-add-modal__content');
        if (!popupWrapper || !exploreMoreGrid || !selectedOption) return;
        quickAdd?.classList.add('overflow-hidden');
        const selectedValue = selectedOption.getAttribute('value');
        const seen = new Set();
        const uniqueLabels = Array.from(this.querySelectorAll('.product-type-label:not(#explore_more_grid .product-type-label)')).filter(l => {
          const v = l.getAttribute('data-value');
          if (seen.has(v)) return false;
          seen.add(v);
          return true;
        });

        popupWrapper.classList.add('popup-active');
        exploreMoreGrid.innerHTML = uniqueLabels.map(l => l.outerHTML).join('');
        const gridLabels = exploreMoreGrid.querySelectorAll('.product-type-label');
        gridLabels.forEach(label => {
          const value = label.getAttribute('data-value');
          if (value === selectedValue) label.classList.add('active-product-type-label');
          label.addEventListener('click', () => {
            gridLabels.forEach(l => l.classList.remove('active-product-type-label'));
            label.classList.add('active-product-type-label');
            const productOptions = this.querySelectorAll("input[option-name='option--product-type']");
            for (const option of productOptions) {
              if (option.getAttribute('data-value') === value) {
                const labelEl = option.nextElementSibling;
                if (labelEl) labelEl.click();
                popupWrapper.classList.remove('popup-active');
                break;
              }
            }
          }, { once: true });
        });
        const closeBtn = this.querySelector('.popup-close-icon');
        if (closeBtn && !closeBtn.dataset.bound) {
          closeBtn.addEventListener('click', () => {
            quickAdd?.classList.remove('overflow-hidden');
            popupWrapper?.classList.remove('popup-active');
          });
          closeBtn.dataset.bound = 'true';
        }
      }


      sizeGuide(selectedOption) {
        const sizeGuidePopup = this.querySelector('.size-guide-popup-head');
        if (!sizeGuidePopup) return;

        sizeGuidePopup?.classList.remove('hidden');

        const optionProductTypeContent = this.querySelectorAll('.option--product-type-content');
        const sizeChartList = this.querySelectorAll('.size-chart-list');
        const optionSizeLabel = this.querySelectorAll('.option-size-label');

        const updateTableOnActive = () => {
          const tableDataList = this.querySelectorAll('.size-chart-list.option--active .table_data');
          const optionStyleActive = this.querySelector('.option-size-label.option--active');
          if (!optionStyleActive) return;

          const dataStyleLabel = optionStyleActive.getAttribute('data-style-label');

          tableDataList.forEach((table) => {
            const tableLabel = table.getAttribute('data-sizename');
            if (tableLabel === dataStyleLabel) {
              table.classList.add('active--table');
            } else {
              table.classList.remove('active--table');
            }
          });
        };

        const filterLabelsByTables = () => {
          const tableDataList = this.querySelectorAll('.size-chart-list.option--active .table_data');

          optionSizeLabel.forEach((label) => {
            const dataStyleLabel = label.getAttribute('data-style-label');
            let hasMatch = false;

            tableDataList.forEach((table) => {
              const tableLabel = table.getAttribute('data-sizename');
              if (dataStyleLabel === tableLabel) {
                hasMatch = true;
              }
            });

            if (hasMatch) {
              label.classList.remove('hidden');
            } else {
              label.classList.add('hidden');
              label.classList.remove('option--active');
            }
          });

          const firstVisible = this.querySelector('.option-size-label:not(.hidden)');
          if (firstVisible && !this.querySelector('.option-size-label.option--active')) {
            firstVisible.classList.add('option--active');
          }

          updateTableOnActive();
          applyUnitFilter();
        };

        const arrows = this.querySelectorAll('.size-guide-popup-head span.svg-wrapper.slider-arrow');
        const items = Array.from(optionProductTypeContent);

        const activateProductType = (item) => {
          optionProductTypeContent.forEach(el => el.classList.remove('option--active'));
          item.classList.add('option--active');

          const productTypeHandle = item.getAttribute('product-type-handle');
          if (!productTypeHandle) return;

          sizeChartList.forEach((chart) => {
            const chartLabel = chart.getAttribute('data-variant-label');
            if (chartLabel === productTypeHandle) {
              chart.classList.add('option--active');
            } else {
              chart.classList.remove('option--active');
            }
          });

          optionSizeLabel.forEach(l => l.classList.remove('option--active'));

          filterLabelsByTables();
          applyUnitFilter();
        };

        arrows.forEach((arrow) => {
          if (arrow.dataset.bound) return;
          arrow.dataset.bound = 'true';

          arrow.addEventListener('click', () => {
            const current = this.querySelector('.option--product-type-content.option--active');
            if (!current) return;

            const currentIndex = items.indexOf(current);
            if (currentIndex === -1) return;

            let newIndex;

            if (arrow.classList.contains('next')) {
              newIndex = (currentIndex + 1) % items.length;
            } else if (arrow.classList.contains('prev')) {
              newIndex = (currentIndex - 1 + items.length) % items.length;
            }

            const nextItem = items[newIndex];
            if (nextItem) activateProductType(nextItem);
          });
        });

        optionSizeLabel.forEach((label) => {
          if (label.dataset.bound) return;
          label.dataset.bound = 'true';

          label.addEventListener('click', () => {
            if (label.classList.contains('hidden')) return;

            optionSizeLabel.forEach(l => l.classList.remove('option--active'));
            label.classList.add('option--active');

            updateTableOnActive();
            applyUnitFilter();
          });
        });

        const closeBtn = this.querySelector('.size-guide--close-icon');
        if (closeBtn && !closeBtn.dataset.bound) {
          closeBtn.dataset.bound = 'true';
          closeBtn.addEventListener('click', () => {
            sizeGuidePopup?.classList.add('hidden');
          });
        }

        if (!this.querySelector('.option--product-type-content.option--active')) {
          optionProductTypeContent[0]?.classList.add('option--active');
          sizeChartList[0]?.classList.add('option--active');
        }

        // New reusable function
        const applyUnitFilter = () => {
          const activeUnit = this.querySelector('.option-unit-label.option--active');
          if (!activeUnit) return;

          const unitValue = activeUnit.getAttribute('data-value');
          const tableDataAll = this.querySelectorAll('.table_data.active--table');

          tableDataAll.forEach((tableData) => {
            const tableDataUnit = tableData.getAttribute('data-option')?.split('-')[1];
            if (tableDataUnit === unitValue) {
              tableData.classList.add('table-unit-active');
            } else {
              tableData.classList.remove('table-unit-active');
            }
          });
        };

        // Bind click events (only once)
        const optionUnitLabelAll = this.querySelectorAll('.option-unit-label');
        optionUnitLabelAll.forEach((optionUnitLabel) => {
          if (optionUnitLabel.dataset.bound) return;
          optionUnitLabel.dataset.bound = 'true';

          optionUnitLabel.addEventListener('click', () => {
            optionUnitLabelAll.forEach(l => l.classList.remove('option--active'));
            optionUnitLabel.classList.add('option--active');
            applyUnitFilter();
          });
        });


        filterLabelsByTables();
        applyUnitFilter();
        this.sizeGuideSlider();
      }


      sizeGuideSlider() {
        const slider = this.querySelector('.option--product-type');
        const slides = slider.querySelectorAll('.option--product-type-content');
        const prevBtn = this.querySelector('.slider-arrow.prev');
        const nextBtn = this.querySelector('.slider-arrow.next');

        let currentIndex = [...slides].findIndex(s => s.classList.contains('option--active'));
        if (currentIndex === -1) currentIndex = 0;

        function updateActiveSlide(index, smooth = true) {
          slides.forEach(s => s.classList.remove('option--active', 'active--slider'));
          slides[index].classList.add('option--active', 'active--slider');
          slides[index].scrollIntoView({
            behavior: smooth ? 'smooth' : 'auto',
            inline: 'center',
            block: 'nearest'
          });
        }

        prevBtn.addEventListener('click', () => {
          currentIndex = (currentIndex - 1 + slides.length) % slides.length;
          updateActiveSlide(currentIndex);
        });

        nextBtn.addEventListener('click', () => {
          currentIndex = (currentIndex + 1) % slides.length;
          updateActiveSlide(currentIndex);
        });

        slides.forEach((slide, index) => {
          slide.addEventListener('click', () => {
            currentIndex = index;
            updateActiveSlide(currentIndex);
          });
        });

        // Ensure active slide is visible on load without smooth scroll
        requestAnimationFrame(() => {
          updateActiveSlide(currentIndex, false);
        });
      }


      updateVariantInputs(variantId) {
        this.querySelectorAll(
          `#product-form-${this.dataset.section}, #product-form-installment-${this.dataset.section}`
        ).forEach((productForm) => {
          const input = productForm.querySelector('input[name="id"]');
          input.value = variantId ?? '';
          input.dispatchEvent(new Event('change', { bubbles: true }));
        });
      }

      updateURL(url, variantId) {
        this.querySelector('share-button')?.updateUrl(
          `${window.shopUrl}${url}${variantId ? `?variant=${variantId}` : ''}`
        );

        if (this.dataset.updateUrl === 'false') return;
        window.history.replaceState({}, '', `${url}${variantId ? `?variant=${variantId}` : ''}`);
      }

      setUnavailable(priceLoader) {
        // priceLoader.classList.remove('hidden');
        this.productForm?.toggleSubmitButton(true, window.variantStrings.unavailable);

        const selectors = ['price', 'Inventory', 'Sku', 'Price-Per-Item', 'Volume-Note', 'Volume', 'Quantity-Rules']
          .map((id) => `#${id}-${this.dataset.section}`)
          .join(', ');
        document.querySelectorAll(selectors).forEach(({ classList }) => classList.add('hidden'));
      }

      updateMedia(html, variantFeaturedMediaId) {
        if (!variantFeaturedMediaId) return;

        const mediaGallerySource = this.querySelector('media-gallery ul');
        const mediaGalleryDestination = html.querySelector(`media-gallery ul`);

        const refreshSourceData = () => {
          if (this.hasAttribute('data-zoom-on-hover')) enableZoomOnHover(2);
          const mediaGallerySourceItems = Array.from(mediaGallerySource.querySelectorAll('li[data-media-id]'));
          const sourceSet = new Set(mediaGallerySourceItems.map((item) => item.dataset.mediaId));
          const sourceMap = new Map(
            mediaGallerySourceItems.map((item, index) => [item.dataset.mediaId, { item, index }])
          );
          return [mediaGallerySourceItems, sourceSet, sourceMap];
        };

        if (mediaGallerySource && mediaGalleryDestination) {
          let [mediaGallerySourceItems, sourceSet, sourceMap] = refreshSourceData();
          const mediaGalleryDestinationItems = Array.from(
            mediaGalleryDestination.querySelectorAll('li[data-media-id]')
          );
          const destinationSet = new Set(mediaGalleryDestinationItems.map(({ dataset }) => dataset.mediaId));
          let shouldRefresh = false;

          // add items from new data not present in DOM
          for (let i = mediaGalleryDestinationItems.length - 1; i >= 0; i--) {
            if (!sourceSet.has(mediaGalleryDestinationItems[i].dataset.mediaId)) {
              mediaGallerySource.prepend(mediaGalleryDestinationItems[i]);
              shouldRefresh = true;
            }
          }

          // remove items from DOM not present in new data
          for (let i = 0; i < mediaGallerySourceItems.length; i++) {
            if (!destinationSet.has(mediaGallerySourceItems[i].dataset.mediaId)) {
              mediaGallerySourceItems[i].remove();
              shouldRefresh = true;
            }
          }

          // refresh
          if (shouldRefresh) [mediaGallerySourceItems, sourceSet, sourceMap] = refreshSourceData();

          // if media galleries don't match, sort to match new data order
          mediaGalleryDestinationItems.forEach((destinationItem, destinationIndex) => {
            const sourceData = sourceMap.get(destinationItem.dataset.mediaId);

            if (sourceData && sourceData.index !== destinationIndex) {
              mediaGallerySource.insertBefore(
                sourceData.item,
                mediaGallerySource.querySelector(`li:nth-of-type(${destinationIndex + 1})`)
              );

              // refresh source now that it has been modified
              [mediaGallerySourceItems, sourceSet, sourceMap] = refreshSourceData();
            }
          });
        }

        // set featured media as active in the media gallery
        this.querySelector(`media-gallery`)?.setActiveMedia?.(
          `${this.dataset.section}-${variantFeaturedMediaId}`,
          true
        );

        // update media modal
        const modalContent = this.productModal?.querySelector(`.product-media-modal__content`);
        const newModalContent = html.querySelector(`product-modal .product-media-modal__content`);
        if (modalContent && newModalContent) modalContent.innerHTML = newModalContent.innerHTML;
      }

      setQuantityBoundries() {
        const data = {
          cartQuantity: this.quantityInput.dataset.cartQuantity ? parseInt(this.quantityInput.dataset.cartQuantity) : 0,
          min: this.quantityInput.dataset.min ? parseInt(this.quantityInput.dataset.min) : 1,
          max: this.quantityInput.dataset.max ? parseInt(this.quantityInput.dataset.max) : null,
          step: this.quantityInput.step ? parseInt(this.quantityInput.step) : 1,
        };

        let min = data.min;
        const max = data.max === null ? data.max : data.max - data.cartQuantity;
        if (max !== null) min = Math.min(min, max);
        if (data.cartQuantity >= data.min) min = Math.min(min, data.step);

        this.quantityInput.min = min;

        if (max) {
          this.quantityInput.max = max;
        } else {
          this.quantityInput.removeAttribute('max');
        }
        this.quantityInput.value = min;

        publish(PUB_SUB_EVENTS.quantityUpdate, undefined);
      }

      fetchQuantityRules() {
        const currentVariantId = this.productForm?.variantIdInput?.value;
        if (!currentVariantId) return;

        this.querySelector('.quantity__rules-cart .loading__spinner').classList.remove('hidden');
        return fetch(`${this.dataset.url}?variant=${currentVariantId}&section_id=${this.dataset.section}`)
          .then((response) => response.text())
          .then((responseText) => {
            const html = new DOMParser().parseFromString(responseText, 'text/html');
            this.updateQuantityRules(this.dataset.section, html);
          })
          .catch((e) => console.error(e))
          .finally(() => this.querySelector('.quantity__rules-cart .loading__spinner').classList.add('hidden'));
      }

      updateQuantityRules(sectionId, html) {
        if (!this.quantityInput) return;
        this.setQuantityBoundries();

        const quantityFormUpdated = html.getElementById(`Quantity-Form-${sectionId}`);
        const selectors = ['.quantity__input', '.quantity__rules', '.quantity__label'];
        for (let selector of selectors) {
          const current = this.quantityForm.querySelector(selector);
          const updated = quantityFormUpdated.querySelector(selector);
          if (!current || !updated) continue;
          if (selector === '.quantity__input') {
            const attributes = ['data-cart-quantity', 'data-min', 'data-max', 'step'];
            for (let attribute of attributes) {
              const valueUpdated = updated.getAttribute(attribute);
              if (valueUpdated !== null) {
                current.setAttribute(attribute, valueUpdated);
              } else {
                current.removeAttribute(attribute);
              }
            }
          } else {
            current.innerHTML = updated.innerHTML;
            if (selector === '.quantity__label') {
              const updatedAriaLabelledBy = updated.getAttribute('aria-labelledby');
              if (updatedAriaLabelledBy) {
                current.setAttribute('aria-labelledby', updatedAriaLabelledBy);
                // Update the referenced visually hidden element
                const labelId = updatedAriaLabelledBy;
                const currentHiddenLabel = document.getElementById(labelId);
                const updatedHiddenLabel = html.getElementById(labelId);
                if (currentHiddenLabel && updatedHiddenLabel) {
                  currentHiddenLabel.textContent = updatedHiddenLabel.textContent;
                }
              }
            }
          }
        }
      }

      get productForm() {
        return this.querySelector(`product-form`);
      }

      get productModal() {
        return document.querySelector(`#ProductModal-${this.dataset.section}`);
      }

      get pickupAvailability() {
        return this.querySelector(`pickup-availability`);
      }

      get variantSelectors() {
        return this.querySelector('variant-selects');
      }

      get relatedProducts() {
        const relatedProductsSectionId = SectionId.getIdForSection(
          SectionId.parseId(this.sectionId),
          'related-products'
        );
        return document.querySelector(`product-recommendations[data-section-id^="${relatedProductsSectionId}"]`);
      }

      get quickOrderList() {
        const quickOrderListSectionId = SectionId.getIdForSection(
          SectionId.parseId(this.sectionId),
          'quick_order_list'
        );
        return document.querySelector(`quick-order-list[data-id^="${quickOrderListSectionId}"]`);
      }

      get sectionId() {
        return this.dataset.originalSection || this.dataset.section;
      }
    }
  );
}



